import { BaseState } from '@/store/base-state';
import { Filters, TableOptions } from '@/types';
import { DataPilot } from '@/modules/data-pilot/types';

export class ProductState extends BaseState {
  filters: Filters = {
    search: '',
    tag_ids: [],
    event_ids: [],
    addresses: [],
    client_id: null,
  };

  products: DataPilot.Device[] = [];
  events: DataPilot.Event[] = [];

  table_options: TableOptions = {
    ...this.create_table_opts,
    sortBy: [''],
    sortDesc: [true],
  };

  loading = false;
}
